export default "__VITE_ASSET__xULYuFoi__"